import { CSSProperties } from 'react';
import { theme } from '../../theme';
import { cardStatusModalStyles } from '../CardStatusModal/styles';

export type ConfirmDeleteCardModalLayout = 'sheet' | 'dialog';

const shared = {
  actions: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing.extraSmall,
  } as CSSProperties,

  cancelButton: {
    width: '100%',
    boxSizing: 'border-box',
    padding: `${theme.spacing.small}px ${theme.spacing.medium}px`,
    border: 'none',
    borderRadius: theme.radius.md,
    backgroundColor: 'transparent',
    color: theme.colors.button.primary,
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.typography.fontSize.base,
    fontWeight: theme.typography.fontWeight.bold,
    cursor: 'pointer',
  } as CSSProperties,

  disabled: {
    opacity: 0.6,
    cursor: 'not-allowed',
  } as CSSProperties,
};

const sheetStyles = {
  ...cardStatusModalStyles,
  ...shared,
};

const dialogStyles = {
  ...sheetStyles,

  overlay: {
    ...cardStatusModalStyles.overlay,
    alignItems: 'center',
    padding: theme.spacing.large,
    boxSizing: 'border-box',
  } as CSSProperties,

  sheet: {
    ...cardStatusModalStyles.sheet,
    width: '100%',
    maxWidth: 440,
    borderRadius: theme.radius.md,
    borderTopLeftRadius: theme.radius.md,
    borderTopRightRadius: theme.radius.md,
    padding: `${theme.spacing.extraLarge}px ${theme.spacing.extraLarge}px ${theme.spacing.large}px`,
    gap: theme.spacing.medium,
    boxShadow: theme.shadows.md,
  } as CSSProperties,

  iconWrapper: {
    marginTop: theme.spacing.small,
  } as CSSProperties,

  title: {
    ...cardStatusModalStyles.title,
    fontSize: theme.typography.fontSize.xl,
    lineHeight: theme.typography.lineHeight.xl,
    maxWidth: 360,
  } as CSSProperties,

  description: {
    ...cardStatusModalStyles.message,
    margin: `0 0 ${theme.spacing.small}px`,
    maxWidth: 360,
    fontSize: theme.typography.fontSize.base,
    lineHeight: theme.typography.lineHeight.base,
    color: theme.colors.subtitle,
  } as CSSProperties,

  last4: {
    fontFamily: theme.typography.cardFontFamily,
    fontWeight: theme.typography.fontWeight.bold,
    color: theme.colors.palette.darkGrey200,
  } as CSSProperties,

  actions: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing.medium,
    marginTop: theme.spacing.small,
  } as CSSProperties,

  cancelButton: {
    flex: 1,
    boxSizing: 'border-box',
    padding: `${theme.spacing.small}px ${theme.spacing.medium}px`,
    border: `2px solid ${theme.colors.button.primary}`,
    borderRadius: theme.radius.md,
    backgroundColor: theme.colors.white,
    color: theme.colors.button.primary,
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.typography.fontSize.base,
    fontWeight: theme.typography.fontWeight.bold,
    cursor: 'pointer',
  } as CSSProperties,

  doneButton: {
    ...cardStatusModalStyles.doneButton,
    flex: 1,
    backgroundColor: theme.colors.palette.red200,
  } as CSSProperties,
};

/** Bottom sheet (app / mobile); `dialog` = modal centrado en checkout web. */
export function getConfirmDeleteCardModalStyles(layout: ConfirmDeleteCardModalLayout) {
  return layout === 'dialog' ? dialogStyles : sheetStyles;
}

/** @deprecated Usar getConfirmDeleteCardModalStyles — se mantiene para imports existentes. */
export const confirmDeleteCardModalStyles = sheetStyles;
